import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import type { IOrdersContextValue } from './types';

export default createContext<IOrdersContextValue>({
  state: initialState,
  actions: initialActionsState,
});
